import React, { useEffect } from "react";
import Product from "./Product";
import LoaderBox from "../../Components/Loader";
import MessageBox from "../../Components/MessageBox";
import { useDispatch, useSelector } from "react-redux";
import { listProducts } from "../../store/actions/productListActions";
import Slideshow from "../../Components/Carousel";
function Home() {
  const productList = useSelector((state) => state.productList);
  const { loading, error, products } = productList;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(listProducts());
  }, [dispatch]);

  return (
    <>
      <div className="vh100">
        {loading ? (
          <LoaderBox />
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <Slideshow />
            <div className="ecommerceCardsBody container mt20 pr10">
              {products.map((data) => {
                return <Product data={data} key={data._id} />;
              })}
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default Home;
